"use strict";
exports.__esModule = true;
exports.getOptionLabel = void 0;
var utils_1 = require("../select/utils");
exports.getOptionLabel = function (option) {
    if (option.name)
        return option.name;
    if (utils_1.isUOptionSet(option))
        return option.uuid;
    if (option.id)
        return String(option.id);
    return '';
};
